<template>
  <header id="header" class="header d-flex align-items-center fixed-top">
    <div
      class="container-fluid container-xl position-relative d-flex align-items-center justify-content-between"
    >
      <router-link to="/e-paiement" class="logo d-flex align-items-center">
        <!-- Uncomment the line below if you also wish to use an image logo 
        <img src="../../assets/images/logo.png" alt="">-->
        <h1 class="sitename">SOGEMA EN LIQUIDATION</h1>
      </router-link>

      <nav id="navmenu" class="navmenu">
        <ul>
          <li><a href="#" class="active">SOGEMA</a></li>
          <li><router-link to="/login">Se connecter</router-link></li>
        </ul>
        <i class="mobile-nav-toggle d-xl-none bi bi-list" @click="toggleMobileNav"></i>
      </nav>
    </div>
  </header>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

export default defineComponent({
  name: "HeaderV",
  setup() {
    //
    const isMobileNavActive = ref(false);

    const toggleMobileNav = (): void => {
      const body = document.body;
      isMobileNavActive.value = !isMobileNavActive.value;

      if (isMobileNavActive.value) {
        body.classList.add("mobile-nav-active");
      } else {
        body.classList.remove("mobile-nav-active");
      }
    };

    return {
      isMobileNavActive,
      toggleMobileNav,
    };
  },
});
</script>

<style scoped>
.header {
  --background-color: #005e48;
}
a {
  text-decoration: none;
}
</style>